interface FormIntroFields {
    form_instructions?: string | null;
    instructions_before_start?: boolean | null;
}

interface PageIndexRef {
    page_index: number;
}

/** True when the form shows its instructions once on a screen before the first question. */
export function formUsesIntroScreen(form: FormIntroFields | null | undefined): boolean {
    return form?.instructions_before_start === true && Boolean(form.form_instructions?.trim());
}

export function firstFormPageIndex(pages: PageIndexRef[] | null | undefined): number {
    if (!pages?.length) return 1;
    return Math.min(...pages.map((page) => page.page_index));
}

/**
 * Whether to render the intro screen instead of the first question.
 *
 * `started` is the stored choice: true once Next was pressed, false after going Back
 * onto the intro, undefined when nothing was stored. With nothing stored, an entry that
 * already has answers (for example after a reload) skips the intro.
 */
export function shouldShowFormIntro(input: {
    usesIntroScreen: boolean;
    isFirstPage: boolean;
    started: boolean | undefined;
    hasStoredAnswers: boolean;
}): boolean {
    if (!input.usesIntroScreen || !input.isFirstPage) return false;
    if (input.started !== undefined) return !input.started;
    return !input.hasStoredAnswers;
}
